import { formatTime } from "./formatTime";

export function initVideoControllers() {
  const videos = document.querySelectorAll(".video");
  const progressBars = document.querySelectorAll(".controller__range");
  const toggleButtons = document.querySelectorAll(".controller__toggle img");
  const timeDisplays = document.querySelectorAll(".controller__time");
  const totalTimeDisplays = document.querySelectorAll(".controller__fulltime");

  if (
    !(
      videos.length &&
      progressBars.length &&
      toggleButtons.length &&
      timeDisplays.length &&
      totalTimeDisplays.length
    )
  )
    return;

  videos.forEach((video, index) => {
    const progressBar = progressBars[index];
    const toggleButton = toggleButtons[index];
    const timeDisplay = timeDisplays[index];
    const totalTimeDisplay = totalTimeDisplays[index];

    //  updating time in video controller
    function updateVideoTime() {
      const currentTime = video.currentTime;
      const duration = video.duration;

      progressBar.value = (currentTime / duration) * 100;

      timeDisplay.textContent = formatTime(currentTime);
      totalTimeDisplay.textContent = formatTime(duration);
    }

    //toggle play-pause
    function togglePlay() {
      if (video.paused) {
        video.play();
        toggleButton.src =
          "/wp-content/themes/ems/project/src/assets/icons/pause.svg";
      } else {
        video.pause();
        toggleButton.src =
          "/wp-content/themes/ems/project/src/assets/icons/play.svg";
      }
    }

    // add eventListener
    video.addEventListener("timeupdate", updateVideoTime);
    toggleButton.addEventListener("click", togglePlay);
  });
}

/*


  //  updating time in video controller
  function updateVideoTime() {
    const currentTime = video.currentTime;
    const duration = video.duration;

    progressBar.value = (currentTime / duration) * 100;

    timeDisplay.textContent = formatTime(currentTime);
    totalTimeDisplay.textContent = formatTime(duration);
  }

  //toggle play-pause
  function togglePlay() {
    if (video.paused) {
      video.play();
      toggleButton.src =
        "/wp-content/themes/ems/project/src/assets/icons/pause.svg";
    } else {
      video.pause();
      toggleButton.src =
        "/wp-content/themes/ems/project/src/assets/icons/play.svg";
    }
  }

  // add eventListener
  video.addEventListener("timeupdate", updateVideoTime);
  toggleButton.addEventListener("click", togglePlay);
*/
